import { useEffect, useState } from 'react';
import { Flex } from 'foundations-components/components/Flex';
import { useIsUngated } from 'portals-platform-lib';
import { GATES } from '../constants/gates';
import { PAGE_CONTENT_SPACING } from '../constants/layout';
import { usageTracker } from '../utils/usageTracker';
import { InboxNavPanel } from '../components/InboxNavPanel';
import { TicketInfoPanel } from '../components/TicketInfoPanel';
import { TicketThreadViewerWrapper } from '../components/TicketThreadViewerWrapper';
import { LegacyTicketThreadViewerWrapper } from '../components/LegacyTicketThreadViewerWrapper';
import { useIsMobile } from '../hooks/useBreakpoint';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function TicketDetails() {
  const isInboxNavEnabled = useIsUngated(GATES.INBOX_NAVIGATION);
  const isMobile = useIsMobile();

  // combined panel state (gated-on path)
  const [isPanelOpen, setIsPanelOpen] = useState(false);
  // legacy panel state (gated-off path)
  const [isInfoPanelOpen, setIsInfoPanelOpen] = useState(false);
  const [isAttachmentsPanelOpen, setIsAttachmentsPanelOpen] = useState(false);
  useEffect(() => {
    usageTracker.track('Customer Portal App', 'Page Viewed', {
      screen: 'ticket-details'
    });
  }, []);
  const outerFlexProps = isMobile ? {} : {
    borderWidth: '100',
    borderStyle: 'solid',
    borderColor: 'border-core-subtle',
    borderRadius: '300',
    overflow: 'hidden',
    marginBlockEnd: PAGE_CONTENT_SPACING,
    marginInlineStart: PAGE_CONTENT_SPACING,
    marginInlineEnd: PAGE_CONTENT_SPACING
  };
  if (isInboxNavEnabled) {
    return /*#__PURE__*/_jsxs(Flex, Object.assign({
      flexGrow: "1"
    }, outerFlexProps, {
      children: [!isMobile && /*#__PURE__*/_jsx(InboxNavPanel, {}), /*#__PURE__*/_jsx(TicketThreadViewerWrapper, {
        isPanelOpen: isPanelOpen,
        setIsPanelOpen: setIsPanelOpen
      })]
    }));
  }
  return /*#__PURE__*/_jsxs(Flex, Object.assign({
    flexGrow: "1"
  }, outerFlexProps, {
    children: [/*#__PURE__*/_jsx(TicketInfoPanel, {
      isMobile: isMobile,
      isInfoPanelOpen: isInfoPanelOpen,
      setIsInfoPanelOpen: setIsInfoPanelOpen
    }), /*#__PURE__*/_jsx(LegacyTicketThreadViewerWrapper, {
      setIsInfoPanelOpen: setIsInfoPanelOpen,
      isAttachmentsPanelOpen: isAttachmentsPanelOpen,
      setIsAttachmentsPanelOpen: setIsAttachmentsPanelOpen
    })]
  }));
}